import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
// import { isCorpClientSelector, isRestrictedCorpMemberSelector } from '../Login/state/loginReselect';
import { connect } from 'react-redux';
import { CASE_DATA_COLLECT_URL } from 'src/constants/constants';
import RightPanelContainer from './Container/RightPanelContainer';

class CaseDataCollectRoot extends Component {
  componentDidMount() {}
  componentWillUnmount() {}
  render() {
    return (
      <Layout headerName={'case data collect'}>
        <Switch>
          <Route path={CASE_DATA_COLLECT_URL} render={props => <RightPanelContainer {...props} />} />
        </Switch>
      </Layout>
    );
  }
}

// export default DashboardRoot;

const mapStateToProps = state => {
  return {
    // isCorpClient: isCorpClientSelector(state),
    // isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CaseDataCollectRoot);
